(() => {
  const init = () => document.querySelectorAll('[data-premium-product]').forEach(root => {
    const dialog = root.querySelector('[data-photo-viewer]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const photos = Array.from(root.querySelectorAll('[data-photo-zoom]'));
    if (!photos.length) return;
    const track = dialog.querySelector('[data-photo-track]');
    const position = dialog.querySelector('[data-photo-position]');
    const previous = dialog.querySelector('[data-photo-previous]');
    const next = dialog.querySelector('[data-photo-next]');
    const hover = matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)');
    let index = 0;
    let opener;
    let built = false;
    let start;
    let swipedUntil = 0;
    const update = () => {
      index = Math.max(0, Math.min(photos.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      position.textContent = position.dataset.label.replace('__INDEX__', index + 1).replace('__COUNT__', photos.length);
      previous.disabled = index === 0;
      next.disabled = index === photos.length - 1;
    };
    const move = target => track.scrollTo({left: Math.max(0, Math.min(photos.length - 1, target)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    const open = photo => {
      if (!built) {
        photos.forEach(item => {
          const slide = document.createElement('div');
          slide.className = 'ew-photo-viewer__slide';
          const image = document.createElement('img');
          image.alt = item.querySelector('img')?.alt || '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = item.dataset.photoZoom;
          slide.appendChild(image);
          track.appendChild(slide);
        });
        built = true;
      }
      opener = photo;
      dialog.showModal();
      document.documentElement.classList.add('ew-photo-viewer-open');
      track.scrollLeft = photos.indexOf(photo) * track.clientWidth;
      update();
      dialog.querySelector('[data-photo-close]').focus({preventScroll:true});
    };
    photos.forEach(photo => {
      const image = photo.querySelector('img');
      if (!image) return;
      photo.addEventListener('pointermove', event => {
        if (!hover.matches || event.pointerType === 'touch') return;
        const bounds = photo.getBoundingClientRect();
        image.style.transformOrigin = `${(event.clientX - bounds.left) / bounds.width * 100}% ${(event.clientY - bounds.top) / bounds.height * 100}%`;
        if (!photo.classList.contains('is-photo-zoomed')) {
          image.removeAttribute('srcset');
          image.src = photo.dataset.photoZoom;
          photo.classList.add('is-photo-zoomed');
        }
      });
      photo.addEventListener('pointerleave', () => photo.classList.remove('is-photo-zoomed'));
      photo.addEventListener('touchstart', event => {
        const touch = event.touches[0];
        start = touch ? {x:touch.clientX,y:touch.clientY} : null;
      }, {passive:true});
      photo.addEventListener('touchmove', event => {
        const touch = event.touches[0];
        if (start && touch && (Math.abs(touch.clientX-start.x)>8 || Math.abs(touch.clientY-start.y)>8)) swipedUntil = Date.now()+700;
      }, {passive:true});
      photo.addEventListener('click', () => { if (Date.now()>swipedUntil) open(photo); });
      photo.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();open(photo);}
      });
    });
    dialog.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ew-photo-viewer-open');
      opener?.focus({preventScroll:true});
    });
    previous.addEventListener('click', () => move(index-1));
    next.addEventListener('click', () => move(index+1));
    track.addEventListener('scroll', update, {passive:true});
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();move(index+(event.key==='ArrowRight'?1:-1));}
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-photo-viewer][open]')) document.documentElement.classList.remove('ew-photo-viewer-open');
  });
})();
